export default __webpack_public_path__ + "img/usefulResources.d2e569af.svg";